module.exports = __webpack_public_path__ + "img/324.35be4132.png";